export default __webpack_public_path__ + "static/media/Clinic_Dir_Bio_Sarah_Lund_Bellevue_05292025.9d6a4c0f.pdf";